import ProductComparisonTable from 'components/ProductComparisonTable';
import * as React from 'react';
export default {
  ProductComparisonTable,
  React
};